import { Transition } from 'DesignSystem2/Theme';

/**
 * This underline effect should be applied to text within a component when the component is hovered.
 *      - The `Primer` CSS properties should be applied to the target text component (or close relative) without condition.
 *      - The `Trigger` CSS properties should be applied only when the correct component is hovered.
 */
export default {
    Primer: {
        background: 'linear-gradient(0deg, currentcolor, currentcolor) no-repeat right bottom / 0 2px',
        paddingBottom: '1px',
        transition: `background-size 300ms ${Transition.easeOutBack}`,
    },
    Trigger: { backgroundSize: '100% 2px', backgroundPositionX: 'left' },
};
